import React from 'react';
import PropTypes from 'prop-types';
import {Typography} from '@customink/pigment-react';

import './Welcome_Lg.scss';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
const StartButtons = props => {
  const {cartItemCount, customDimension, isMultiItemEligible} = props;

  const onAddText = event => {
    props.onAddText(event, customDimension);
    props.onTextStart({
      source: 'wb'
    });
  };
  const onUpload = event => {
    props.onUpload(event, customDimension);
  };

  const onAddArt = event => {
    props.onAddArt(event, customDimension);
  };

  const onProduct = event => {
    props.onProduct(event, customDimension);
  };

  const onCheckout = event => {
    props.onCheckout(event, customDimension);
  };

  const onRetrieveDesigns = event => {
    props.onRetrieveDesigns(event, customDimension);
  };

  const renderMultiItemOptions = () => {
    return (
      <div className="ndx-Flex-Row">
        <div className="ndx-Welcome_Lg-button" onClick={onRetrieveDesigns}>
          <div className="ndx-Welcome_Lg-buttonImage welcomeRetrieveDesignImage" />
          <Typography
            variant="uiTextSmall"
            className="ndx-Welcome_Lg-buttonText">
            Retrieve a
            <br />
            Saved Design
          </Typography>
        </div>
        <div className="ndx-Welcome_Lg-button" onClick={onCheckout}>
          <div className="ndx-Welcome_Lg-buttonImage welcomeCheckoutImage" />
          <Typography
            variant="uiTextSmall"
            className="ndx-Welcome_Lg-buttonText">
            Review Cart &
            <br />
            Checkout
          </Typography>
        </div>
      </div>
    );
  };

  return (
    <div className="ndx-Welcome_Lg-buttons">
      <div className="ndx-Flex-Row">
        <div className="ndx-Welcome_Lg-button" onClick={onUpload}>
          <div className="ndx-Welcome_Lg-buttonImage welcomeUploadCTAImage" />
          <Typography
            variant="uiTextSmall"
            data-testid="StartButton-text"
            className="ndx-Welcome_Lg-buttonText">
            Upload
          </Typography>
        </div>
        <div
          className="ndx-Welcome_Lg-button"
          data-testid="onAddText"
          onClick={onAddText}>
          <div className="ndx-Welcome_Lg-buttonImage welcomeTextCTAImage" />
          <Typography
            variant="uiTextSmall"
            className="ndx-Welcome_Lg-buttonText">
            Add Text
          </Typography>
        </div>
      </div>
      <div className="ndx-Flex-Row">
        <div className="ndx-Welcome_Lg-button" onClick={onAddArt}>
          <div className="ndx-Welcome_Lg-buttonImage welcomeArtCTAImage" />
          <Typography
            variant="uiTextSmall"
            className="ndx-Welcome_Lg-buttonText">
            {'Add Art'}
          </Typography>
        </div>
        <div className="ndx-Welcome_Lg-button" onClick={onProduct}>
          <div className="ndx-Welcome_Lg-buttonImage welcomeProductCTAImage" />
          <Typography
            variant="uiTextSmall"
            className="ndx-Welcome_Lg-buttonText">
            Change
            <br />
            Products
          </Typography>
        </div>
      </div>
      {isMultiItemEligible && cartItemCount > 0 ? renderMultiItemOptions() : ''}
    </div>
  );
};

StartButtons.displayName = 'StartButtons';

const propTypes = {
  cartItemCount: PropTypes.number,
  customDimension: PropTypes.string,
  isMultiItemEligible: PropTypes.bool,
  isWaysToGetStartedTest: PropTypes.bool,
  onAddArt: PropTypes.func,
  onAddText: PropTypes.func,
  onChangeProductColor: PropTypes.func,
  onCheckout: PropTypes.func,
  onProduct: PropTypes.func,
  onRetrieveDesigns: PropTypes.func,
  onTextStart: PropTypes.func,
  onUpload: PropTypes.func
};

StartButtons.propTypes = propTypes;

export default StartButtons;
